import { formatQuantity } from "@common/utils/string";
import { IStorageMark } from "./types";

export const SLIDER_THUMB_SIZE = 24;
export const SLIDER_THUMB_INNER_SIZE = SLIDER_THUMB_SIZE / 2 - 2;

export const SLIDER_MARKS_DEFAULT: IStorageMark[] = [
  {
    value: 0,
    realValue: 500000,
    label: formatQuantity(500000),
  },
  {
    value: 1,
    realValue: 1000000,
    label: formatQuantity(1000000),
  },
  {
    value: 2,
    realValue: 5000000,
    label: formatQuantity(5000000),
  },
  {
    value: 3,
    realValue: 10000000,
    label: formatQuantity(10000000),
  },
  {
    value: 4,
    realValue: 20000000,
    label: formatQuantity(20000000),
  },
];
